import { ImgProps } from "assets/images/types";

export default function ImgDiaDasMaesMmbbMain(props: ImgProps) {
	const { height = 258, width = 517 } = props;
	return (
		<img
			src="/assets/images/cases/dia-das-maes-mmbb/dia-das-maes-mmbb-card.webp"
			alt="Natura Dia das Mães MMBB"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
